import {
  fetchMentorClassAdvisoryMeeting,
  fetchMentorClassAdvisoryMeetingFilters,
} from "classroom/api/teacher";
import type { FilterResource } from "api/generated";
import type { TransitionMeetingMyStudentsOverview } from "meetings/advisory/types";
import { defineStore } from "pinia";

export const useClassroomMentorClassAdvisoryMeetingStore = defineStore(
  "classroomMentorClassAdvisoryMeeting",
  () => {
    const loadAdvisoryMeeting = async (
      mentorClass: string,
      params: Record<string, string> = {},
      signal?: AbortSignal,
    ): Promise<TransitionMeetingMyStudentsOverview> => {
      return fetchMentorClassAdvisoryMeeting(mentorClass, params, signal);
    };

    const loadAdvisoryMeetingFilters = async (
      mentorClass: string,
      signal?: AbortSignal,
    ): Promise<FilterResource[]> => {
      return fetchMentorClassAdvisoryMeetingFilters(mentorClass, signal);
    };

    return { loadAdvisoryMeeting, loadAdvisoryMeetingFilters };
  },
);
